import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Pacotes from './pages/Pacotes';
import PromotionDetails from './pages/PromotionDetails';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from './components/ui/sonner';
import './App.css';

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id synchronously during render before routes
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pacotes" element={<Pacotes />} />
      <Route path="/promotion/:id" element={<PromotionDetails />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/*" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppRouter />
        <Toaster position="top-center" />
      </div>
    </Router>
  );
}

export default App;
